export const enum ErrorMap {
    CALENDAR_READING_PANE_ERROR,
}
